import {lrsAuthToken} from '../../../../environments/environment';

export const lrs = {
    api_endPoint : 'https://lrs.tralalere.com/data/xAPI',
    authorization_token: 'Basic ' + lrsAuthToken()
};
